import RSplit, {SplitProps} from 'react-split'
import _ from 'lodash'
import './style.css'

export type {SplitProps}

export function Split(props: SplitProps) {
  const {className, ...rest} = props

  const classNames = _.chain(['split', className]).compact().join(' ').value()

  return (
    <RSplit
      className={classNames}
      {...rest}
    />
  )
}
